import { blender3DShader } from "./shaders/blender3DShader.js";
import { nebulaShader } from "./shaders/nebulaShader.js";
import { snowShader } from "./shaders/snowShader.js";
import { sunsetShader } from "./shaders/sunsetShader.js";
import { glitchShader } from "./shaders/glitchShader.js";
import { oceanShader } from "./shaders/oceanShader.js";
import { fireShader } from "./shaders/fireShader.js";
import { synthwaveShader } from "./shaders/synthwaveShader.js";
import { staticShader } from "./shaders/staticShader.js";
import { galaxyShader } from "./shaders/galaxyShader.js";
import { forestShader } from "./shaders/forestShader.js";
import { auroraShader } from "./shaders/auroraShader.js";

export const defaultDecorOptions = {
  color: "#ffffff",
  image: "",
  spotify: "spotify.com",
  youtube: "",
  twitch: "",
};
export const materialOptions = [
  // Basics
  {
    label: "Dry Wall",
    value: "0",
    type: "basic",
    materialProps: { color: "#e6e6e6", roughness: 1, metalness: 0 },
    image: "https://placehold.co/60x60/e6e6e6/e6e6e6/png",
  },
  {
    label: "Felt",
    value: "1",
    type: "basic",
    materialProps: { color: "#3a3a3a", roughness: 1, metalness: 0 },
    image: "https://placehold.co/60x60/3a3a3a/3a3a3a/png",
  },
  {
    label: "Metal",
    value: "2",
    type: "basic",
    materialProps: { color: "#aaaaaa", roughness: 0.3, metalness: 1 },
    image: "https://placehold.co/60x60/aaaaaa/aaaaaa/png",
  },
  {
    label: "Paper",
    value: "3",
    type: "basic",
    materialProps: { color: "#faf3dd", roughness: 0.9, metalness: 0 },
    image: "https://placehold.co/60x60/faf3dd/faf3dd/png",
  },
  {
    label: "Glow",
    value: "4",
    type: "basic",
    materialProps: {
      color: "#00ffcc",
      emissive: "#00ffcc",
      emissiveIntensity: 1,
    },
    image: "https://placehold.co/60x60/00ffcc/00ffcc/png",
  },
  {
    label: "Wood",
    value: "5",
    type: "basic",
    materialProps: { color: "#8b5a2b", roughness: 0.8, metalness: 0 },
    image: "https://placehold.co/60x60/8b5a2b/8b5a2b/png",
  },
  {
    label: "Crystal",
    value: "6",
    type: "basic",
    materialProps: {
      color: "#a0e8ff",
      roughness: 0,
      metalness: 0.1,
      transparent: true,
      opacity: 0.6,
    },
    image: "https://placehold.co/60x60/a0e8ff/a0e8ff/png",
  },
  {
    label: "Rough",
    value: "7",
    type: "basic",
    materialProps: { color: "#777777", roughness: 1, metalness: 0 },
    image: "https://placehold.co/60x60/777777/777777/png",
  },

  // Shaders
  {
    label: "Aurora",
    value: "8",
    type: "shader",
    shader: auroraShader,
    image: "/images/shader_thumbnails/aurora.png",
  },
  {
    label: "Snow",
    value: "9",
    type: "shader",
    shader: snowShader,
    image: "/images/shader_thumbnails/snow.png",
  },
  {
    label: "Sunset",
    value: "10",
    type: "shader",
    shader: sunsetShader,
    image: "/images/shader_thumbnails/sunset.png",
  },
  {
    label: "Fire",
    value: "11",
    type: "shader",
    shader: fireShader,
    image: "/images/shader_thumbnails/fire.png",
  },
  {
    label: "Ocean",
    value: "12",
    type: "shader",
    shader: oceanShader,
    image: "/images/shader_thumbnails/ocean.png",
  },
  {
    label: "Forest",
    value: "13",
    type: "shader",
    shader: forestShader,
    image: "/images/shader_thumbnails/forest.png",
  },
  {
    label: "Bloom",
    value: "14",
    type: "shader",
    shader: blender3DShader,
    image: "/images/shader_thumbnails/bloom.png",
  },
  {
    label: "Glitch",
    value: "15",
    type: "shader",
    shader: glitchShader,
    image: "/images/shader_thumbnails/glitch.png",
  },
  {
    label: "Static",
    value: "16",
    type: "shader",
    shader: staticShader,
    image: "/images/shader_thumbnails/static.png",
  },
  {
    label: "Synthwave",
    value: "17",
    type: "shader",
    shader: synthwaveShader,
    image: "/images/shader_thumbnails/synthwave.png",
  },
  {
    label: "Nebula",
    value: "18",
    type: "shader",
    shader: nebulaShader,
    image: "/images/shader_thumbnails/nebula.png",
  },
  {
    label: "Galaxy",
    value: "19",
    type: "shader",
    shader: galaxyShader,
    image: "/images/shader_thumbnails/galaxy.png",
  },

  // Video
  {
    label: "Custom Video",
    value: "20",
    type: "video",
    src: null,
    image: "/images/shader_thumbnails/video.png",
  },

  // Image
  {
    label: "Custom Image",
    value: "21",
    type: "image",
    src: null,
    image: "/images/shader_thumbnails/video.png",
  },

  // Videos (commented out for now)
  // {
  //   label: "City Loop",
  //   value: "10",
  //   type: "video",
  //   src: "/videos/sample.mp4",
  //   image: "/images/nature.png",
  // },
  // {
  //   label: "Nature Loop",
  //   value: "11",
  //   type: "video",
  //   src: "/videos/sample.mp4",
  //   image: "/images/nature.png",
  // },
];

export const iframeOptions = [
  { label: "YouTube", value: "https://www.youtube.com/embed/dQw4w9WgXcQ" },
  {
    label: "Spotify",
    value: "https://open.spotify.com/embed/playlist/37i9dQZF1DXcBWIGoYBM5M",
  },
];
export const youtubeOptions = [
  { label: "YouTube", value: "https://www.youtube.com/embed/dQw4w9WgXcQ" },
];
export const spotifyOptions = [
  {
    label: "Spotify",
    value: "https://open.spotify.com/embed/playlist/37i9dQZF1DXcBWIGoYBM5M",
  },
];

export const imageOptions = [
  {
    label: "Image 150",
    value: "https://placehold.co/600x400/000000/FFFFFF/png",
  },
  { label: "Image 200", value: "https://placehold.co/600x400/orange/white" },
  {
    label: "Image 250",
    value: "https://placehold.co/600x400?text=Hello+World",
  },
];
export const videoOptions = [
  { label: "Sample 1", value: "/videos/sample.mp4?id=0" },
  { label: "Sample 2", value: "/videos/sample.mp4?id=1" },
  { label: "Sample 3", value: "/videos/sample.mp4?id=2" },
];

export const roomColors = [
  // Reds
  "maroon",
  "red",
  "coral",

  // Oranges & Yellows
  "orange",
  "gold",
  "yellow",
  "chocolate",
  "brown",

  // Greens
  "olive",
  "lime",
  "green",
  "teal",

  // Blues
  "cyan",
  "royalblue",
  "blue",
  "navy",
  "indigo",

  // Purples & Pinks
  "violet",
  "purple",
  "magenta",
  "pink",

  // Neutrals
  "silver",
  "gray",
  "black",
  "white",
];
